/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import '@/css/reset.css';
import axios from 'axios';
import Toast from './views/components/Toast/Toast.vue';
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

const ToastConstructor = Vue.extend(Toast);
Vue.prototype.$toast = function (data) {
  document.body.appendChild(new ToastConstructor({
    el: document.createElement('div'),
    propsData: data,
  }).$el);
};

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
